import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Equipment from "./pages/Equipment";
import Users from "./pages/Users";
import Calendar from "./pages/Calendar";
import MyOrders from "./pages/MyOrders";
import Events from "./pages/Events";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import AcceptInvitation from "./pages/AcceptInvitation";
import DailyReports from "./pages/DailyReports";

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors theme="dark" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/invitation/:token" element={<AcceptInvitation />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<Shell><Dashboard /></Shell>} />
              <Route path="/orders" element={<Shell><Orders /></Shell>} />
              <Route path="/my-orders" element={<Shell><MyOrders /></Shell>} />
              <Route path="/daily-reports" element={<Shell><DailyReports /></Shell>} />
              <Route path="/events" element={<Shell><Events /></Shell>} />
              <Route path="/calendar" element={<Shell><Calendar /></Shell>} />
              <Route path="/equipment" element={<Shell><Equipment /></Shell>} />
              <Route path="/users" element={<Shell><AdminOnly><Users /></AdminOnly></Shell>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}
